// import {ANALYTICS_EVENT} from '@redux/types';
import loggerMiddleware from "./logger";
// import handleAnalyticsEvent from '@services/handleAnalyticsEvent';

// const analyticsMiddleware = store => next => action => {
//   if (action.type === ANALYTICS_EVENT) {
//     handleAnalyticsEvent(action);
//   }
//   next(action);
// };

let middleWares = [];

if (__DEV__) {
  middleWares.push(loggerMiddleware);
}

export default middleWares;
